module.exports = __webpack_public_path__ + "img/sint-eustatius.7f9caba8.svg";